export enum PaymentOptions {
    // Portal = 'Online Portal DGITL',
    Selfpay = 'Aparate de plată Selfpay',
    PlataDirectaTrezzo = 'Plată directă cont PS4 Trezorerie',
}
